import { Component, Input, model, viewChildren } from '@angular/core';
import { BooleanInputComponent } from '@common/components/input/boolean-input/boolean-input.component';
import { CodelistInputComponent } from '@common/components/input/codelist-input/codelist-input.component';
import { DateInputComponent } from '@common/components/input/date-input/date-input.component';
import { DaterangeInputComponent } from '@common/components/input/daterange-input/daterange-input.component';
import { DateTimeInputComponent } from '@common/components/input/datetime-input/datetime-input.component';
import { FileInputComponent } from '@common/components/input/file-input/file-input.component';
import { NumberInputComponent } from '@common/components/input/number-input/number-input.component';
import { SelectInputComponent } from '@common/components/input/select-input/select-input.component';
import { TextInputComponent } from '@common/components/input/text-input/text-input.component';
import { TextareaInputComponent } from '@common/components/input/textarea-input/textarea-input.component';
import { BaseInputComponent } from './base-input/base-input.component';
import { InputConfig, InputType } from './input.type';
import { TimeInputComponent } from './time-input.component';

/**
 * General input component that handles all types of inputs.
 * @param value - The input value.
 * @param config - The input configuration.
 */
@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    imports: [
        TextInputComponent,
        NumberInputComponent,
        TextareaInputComponent,
        BooleanInputComponent,
        DateInputComponent,
        DateTimeInputComponent,
        TimeInputComponent,
        DaterangeInputComponent,
        FileInputComponent,
        SelectInputComponent,
        CodelistInputComponent
    ]
})
export class InputComponent {
    public inputs = viewChildren(BaseInputComponent);

    @Input() config: InputConfig;
    value = model.required<any>();
    inputTypes = InputType;
}
